<script context="module">
  export const showAllFields = true;

  const productTileDefaultOptions = {
    showProductTags: showAllFields,
    showFavIcon: showAllFields,
    showPrice: showAllFields,
    showRatingReview: showAllFields,
    showOfferAndGift: showAllFields,
    showBottomTags: showAllFields,
    showActionBtn: showAllFields,
    isBundleProduct: false,
    isRRComponent: false,
    mobileTileWidth: 166,
    desktopTileWidth: 239,
    favIconMobileWidth: 24,
    favIconDesktopWidth: 32,
  };
</script>

<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import {
    checkForMegaSaleProduct,
    getJoodDayTheme,
    getProductTags,
    getStr,
    intersectionObserver,
    IOOptions,
    isMobileWidth,
  } from '../../../common/util';
  import { getBottomTags } from '../../brand/services/brand-data-services';
  import MiraklSponsoredTag from '../../common/components/MiraklSponsoredTag.svelte';
  import ProductCardNewRating from '../../common/components/ProductCardNewRating.svelte';
  import ProductBottomTags from '../../common/components/productTile/components/ProductBottomTags.svelte';
  import ProductQACButton from '../../common/components/productTile/components/ProductQACButton.svelte';
  import ProductTileGift from '../../common/components/productTile/components/ProductTileGift.svelte';
  import ProductTileName from '../../common/components/productTile/components/ProductTileName.svelte';
  import ProductTilePriceNewGroup from '../../common/components/productTile/components/ProductTilePriceNewGroup.svelte';
  import TagContainer from '../../common/components/tag/TagContainer.svelte';
  import { productTileStore } from '../../common/store/product-tile_store';
  import { cartLoginDetails } from '../../header/store/header_store';
  import { onClickWishlistFromPLP } from '../services/plp-data-services';
  import { compareProducts, enableComparison } from '../store/plp-data-store';
  import ProductUtilityBar from './productUtilityBar.svelte';

  export let product;
  export let productIndex;
  export let productCardViewType;
  export let isComparedChecked = false;
  export let options = {};

  let wishlistedProductCodes = [];
  let productStore = null;
  const { lang, pageId, userDefaultCityCode, joodExpiredFlag } = getAppConfig();
  const dispatcher = createEventDispatcher();
  const joodDayTheme = getJoodDayTheme(product);
  product.conditionBuyBoxes = (() => {
    try {
      return JSON.parse(product.conditionBuyBoxes ?? '[]');
    } catch (error) {
      console.error('Failed to parse conditionBuyBoxes', error);
      return [];
    }
  })();

  $: wishlisted = wishlistedProductCodes.indexOf(product.productCode) > -1;
  $: opt = { ...productTileDefaultOptions, ...options };
  $: userCityCode = $cartLoginDetails?.city?.code || userDefaultCityCode;

  $: isComingSoon = product?.comingSoon || false;
  $: isInStock =
    !isComingSoon &&
    ((product?.inStockCities?.length && product.inStockCities.indexOf(userCityCode) != -1) ||
      product.stock?.stockLevelStatus === 'inStock');
  $: isSellingOutFast =
    !isInStock &&
    ((product?.sellingOutFastCities?.length && product.sellingOutFastCities.indexOf(userCityCode) != -1) ||
      product.stock?.stockLevelStatus === 'lowStock');
  $: isRestockable = product?.restockableCities?.includes(userCityCode) || false;
  $: isOutOfStock = !(isComingSoon || isInStock || isSellingOutFast || isRestockable);
  $: productTags =
    isMobileWidth() && productCardViewType === 'grid-view'
      ? getProductTags(product).slice(0, 1)
      : getProductTags(product);
  $: showPriceForComingSoon = !isComingSoon || (isComingSoon && !product?.hidePriceForComingSoon);

  cartLoginDetails.subscribe(cld => {
    wishlistedProductCodes =
      cld?.customer.wishlist?.entries?.filter(x => x.product !== null).map(x => x.product?.code) || [];
  });

  const handleNumofCkdProds = (isMount = false) => {
    console.log($compareProducts, '$compareProducts.length---------------------------');
    if ($compareProducts.length < (isMount ? 5 : 4)) {
      dispatcher('compareToggle', product);
    }
  };

  function onClickCompare(data) {
    data.detail.event.stopPropagation();
    data.detail.event.preventDefault();
    handleNumofCkdProds();
  }

  onMount(() => {
    productStore = productTileStore(product);

    if (!wishlistedProductCodes.length && getAppConfig()?.wishlistProducts?.length && !$cartLoginDetails) {
      wishlistedProductCodes = [...getAppConfig().wishlistProducts];
    }
  });

  const ioParams: IOOptions = {
    once: true,
    callback: callbackToIntersection,
  };

  function callbackToIntersection(_node: HTMLElement) {
    if (product.miraklad) {
      product.miraklad.position = productIndex + 1;
      window.ACC.mixpanel.trackSponsoredPlacementViewed([product], 'PLP');
    }
  }
  console.log('product', product);
</script>

<div
  class="product-tile-card-container"
  use:intersectionObserver={ioParams}
  style:--desktop-tile-width="{opt?.desktopTileWidth}px"
>
  <div
    class="card-container grid"
    style={joodDayTheme?.joodType === 'NOPRIME' ? '' : 'border: 2px solid ' + joodDayTheme?.borderColor}
  >
    <div class="product-adc-icon">
      <ProductQACButton {product} />
    </div>
    <section class="img-cta-wrapper">
      <div class="product-img">
        {#if productStore?.productTileImageData}
          <img
            src="{window.ACC.config.extraThemeResourcePath}/images/spacer_image.gif"
            loading="lazy"
            srcset="{productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&w=90 90w, 
            {productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&w=180 180w, 
            {productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&h=214&w=214 214w,
            {productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&h=428&w=428 428w"
            sizes="(max-width: 899px) 90px, 214px"
            fetchpriority="auto"
            alt="noname"
            style="object-fit: contain; object-position: center center;"
          />
        {/if}
      </div>
      <div class="product-actions">
        <ProductUtilityBar
          {product}
          productCode={product.productCode}
          showCompare={!product.isDigitalGiftCard && pageId == 'productList' && $enableComparison}
          isWishlisted={wishlisted}
          {isComparedChecked}
          on:changeWishList={data => {
            onClickWishlistFromPLP(data, product);
          }}
          on:toggleCompare={data => onClickCompare(data)}
        />
      </div>
    </section>
    <section class="product-details-wrapper">
      <div class="product-tags">
        {#if pageId === 'productDetails' ? !!product?.offerId : !!product?.miraklad}
          <MiraklSponsoredTag variant="PLP_GRID" />
        {/if}
        {#if productTags.length}
          <TagContainer {productTags} />
        {/if}
      </div>
      <div class="rating-section">
        <ProductCardNewRating data={product} {productStore} {opt} isPLP={true} />
      </div>
      <div class="product-name">
        <ProductTileName
          data={{
            miraklSponsored: false,
            brandName: lang === 'en' ? product.brandEn : product.brandAr,
            name: lang === 'en' ? product.nameEn : product.nameAr,
            condition: product?.condition,
          }}
        />
      </div>
      <div class="price-offer-details {joodExpiredFlag ? 'expired-price-offer-details' : ''}">
        <!-- product price detail -->
        {#if showPriceForComingSoon}
          {#if !product.isDigitalGiftCard}
            <section class="price-container">
              <ProductTilePriceNewGroup
                variant="plp-grid"
                {product}
                isMegasaleProduct={getProductTags(product)?.length
                  ? checkForMegaSaleProduct(getProductTags(product))
                  : []}
              />
            </section>
          {/if}
        {/if}
        {#if isComingSoon}
          <div class="coming-soon">
            {getStr('extra.soonmessage')}
          </div>
        {/if}
      </div>
      <div class="product-offers">
        <ProductTileGift {product} />
      </div>
    </section>
  </div>
  <section class="bottom-tags-section">
    {#if !isOutOfStock && (isSellingOutFast || product?.dealTimer?.deals || product?.joodDayRemainingQuantity > 0)}
      <ProductBottomTags
        isPLPGrid={true}
        joodDayData={{
          isJoodDayFlag: joodDayTheme?.joodType,
          joodDayRemainingQuantity: product?.joodDayRemainingQuantity,
        }}
        data={{
          isMegasaleProduct: getProductTags(product)?.length ? checkForMegaSaleProduct(getProductTags(product)) : [],
          tagsData: [...getBottomTags(product)],
        }}
      />
    {/if}
  </section>
</div>

<style lang="scss">
  @import '../../../common/styles/vars.scss';
  @import '../../common/styles/colors.new.scss';
  .product-tile-card-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .product-tile-link {
    display: flex;
    height: 100%;
  }

  .card-container {
    background-color: $primary-white;
    display: flex;
    height: 100%;
    position: relative;
    max-width: var(--desktop-tile-width);
    // @include desktop-max-width {
    //   max-width: var(--mobile-tile-width);
    // }
    .product-adc-icon {
      position: absolute;
      top: 12px;
      right: 12px;
      @include desktop-min-width {
        top: 8px;
        right: 8px;
      }
    }
    .product-tags {
      margin-bottom: 10px;
    }
    .product-name {
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 0.4px solid $color-gray-border;
    }
    .rating-section {
      margin-bottom: 12px;
    }

    &.grid {
      flex-direction: column;
      border-radius: 10px;
      padding: 10px;
      gap: 10px;
      // flex: 1;
      .img-cta-wrapper {
        @include desktop-max-width {
          margin-top: 16px;
        }
        .product-img {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .product-tags {
        min-height: 20px;
        display: flex;
        align-items: center;
        gap: 4px;
      }
      .rating-section {
        min-height: 18px;
      }
    }
  }
  :global {
    .product-adc-icon {
      .qac-button {
        width: 100%;
      }
    }
    .product-qac-button.variant-plp-tile.qac-button {
      background-color: $primary-yellow-02;
    }
    .grid-view .bottom-tags-section {
      min-height: 20px;
    }
    .grid .tag-container {
      font-size: 9px;
      @include desktop-max-width {
        position: absolute;
        top: 8px;
        left: 8px;
      }
    }
  }
</style>
